import ReportScrollableTable from 'features/report/table/ReportScrollableTable'
import MultiTable from 'components/table/MultiTable'
import {
  ReportColumnEndDate,
  ReportColumnStartDate,
} from 'features/report/common/ReportColumns'
import { noop } from 'utils'

const ReportAdAccountTable = () => (
  <div className="table_wrap">
    <MultiTable.Container>
      <ReportScrollableTable
        caption="맞춤보고서 광고계정 테이블"
        onIsScrolledChange={noop}
        baseColumns={[ReportColumnStartDate, ReportColumnEndDate]}
      />
    </MultiTable.Container>
  </div>
)

export default ReportAdAccountTable
